import styles from './WidgetsContainer.module.css'
import { DailySummaryContainer } from "../../containers/DailySummaryContainer"
import { DailySummaryButton } from "../DailySummaryButton"
import { useState } from 'react'
import { Recommendations } from '../Recommendations'
import { FutureMarket } from '../FutureMarket'
import classNames from 'classnames'
import { MapWithCompetitorsContainer } from '../../containers/MapWithCompetitorsContainer'
import { RecommendationsContainer } from '../../containers/RecommendationsContainer'
import { ChartMedianPriceContainer } from '../FutureMarket/containers/ChartMedianPriceContainer'
import { ChartSupplyContainer } from '../FutureMarket/containers/ChartSupplyContainer'
import { ChartDemandContainer } from '../FutureMarket/containers/ChartDemandContainer'
import { ChartCompetitorListContainer } from '../FutureMarket/containers/ChartCompetitorListContainer'

interface WidgetsContainerProps{
    hostServices: any
    hostServicesCount: any
    summary: any
    spyId: any
    filter?: any
    onDateSelectOpenChange?: (event: any) => void
}

export const WidgetsContainer = (props: WidgetsContainerProps): JSX.Element => {
    const {
        hostServices,
        hostServicesCount,
        summary,
        spyId,
        filter,
        onDateSelectOpenChange
    } = props

    const [mode, setMode] = useState<'default' | 'chartMedianPrice' | 'chartSupply' | 'chartDemand' | 'recommendations' | 'dailySummary' | 'chartCompetitors'>('default')

    const handleModeChange = (event: any) => {
        setMode(event)
    }

    const handleDailySummaryContainerDateChange = () => {
        
    }

    const handleDateSelectOpenChange = (event: any) => {
        onDateSelectOpenChange?.(event)
    }

    const handleChartMedianPriceContainerExpand = (event: any) => {
        setMode('chartMedianPrice')
    }

    const handleChartMedianPriceContainerCollapse = (event: any) => {
        setMode('default')
    }

    const handleChartSupplyContainerExpand = (event: any) => {
        setMode('chartSupply')
    }

    const handleChartSupplyContainerCollapse = (event: any) => {
        setMode('default')
    }

    const handleChartDemandContainerExpand = (event: any) => {
        setMode('chartDemand')
    }

    const handleChartDemandContainerCollapse = (event: any) => {
        setMode('default')
    }

    const handleChartCompetitorListContainerExpand = (event: any) => {
        setMode('chartCompetitors')
    }

    const handleChartCompetitorListContainerCollapse = (event: any) => {
        setMode('default')
    }

    const handleRecommendationsContainerExpand = (event: any) => {
        setMode('recommendations')
    }

    const handleRecommendationsContainerCollapse = (event: any) => {
        setMode('default')
    }

    const dailySummaryContainerClasses = classNames(styles.WidgetsContainer__DailySummaryContainer, {
        [styles['WidgetsContainer__DailySummaryContainer--Default']]: mode === 'default',
        [styles['WidgetsContainer__DailySummaryContainer--Expanded']]: mode === 'dailySummary', 
    })   

    const recommendationsContainerClasses = classNames(styles.WidgetsContainer__RecommendationsContainer, {
        [styles['WidgetsContainer__RecommendationsContainer--Default']]: mode === 'default',
        [styles['WidgetsContainer__RecommendationsContainer--Expanded']]: mode === 'recommendations', 
    })

    const chartMedianPriceContainerClasses = classNames(styles.WidgetsContainer__ChartMedianPriceContainer, {
        [styles['WidgetsContainer__ChartMedianPriceContainer--Default']]: mode === 'default',
        [styles['WidgetsContainer__ChartMedianPriceContainer--Expanded']]: mode === 'chartMedianPrice', 
    })

    const chartSupplyContainerClasses = classNames(styles.WidgetsContainer__ChartSupplyContainer, {
        [styles['WidgetsContainer__ChartSupplyContainer--Default']]: mode === 'default',
        [styles['WidgetsContainer__ChartSupplyContainer--Expanded']]: mode === 'chartSupply', 
    })

    const chartDemandContainerClasses = classNames(styles.WidgetsContainer__ChartDemandContainer, {
        [styles['WidgetsContainer__ChartDemandContainer--Default']]: mode === 'default',
        [styles['WidgetsContainer__ChartDemandContainer--Expanded']]: mode === 'chartDemand', 
    })

    const chartChartCompetitorListContainerClasses = classNames(styles.WidgetsContainer__ChartCompetitorListContainer, {
        [styles['WidgetsContainer__ChartCompetitorListContainer--Default']]: mode === 'default',
        [styles['WidgetsContainer__ChartCompetitorListContainer--Expanded']]: mode === 'chartCompetitors', 
    })

    const renderContent = () => {
        if (spyId === undefined){
            return (null)
        }

        return (
            <>
                <div className={dailySummaryContainerClasses}>
                    <DailySummaryContainer 
                        spyId={spyId}
                        summary={summary}
                        onModeChange={handleModeChange}
                        onDateChange={handleDailySummaryContainerDateChange}
                        onDateSelectOpenChange={handleDateSelectOpenChange}
                    />   
                </div> 
                <div className={chartMedianPriceContainerClasses}>
                    <ChartMedianPriceContainer 
                        spyId={spyId}
                        filter={filter}
                        expanded={mode === 'chartMedianPrice'}
                        onExpand={handleChartMedianPriceContainerExpand}
                        onCollapse={handleChartMedianPriceContainerCollapse}
                    />
                </div>
                 <div className={chartSupplyContainerClasses}>
                    <ChartSupplyContainer 
                        spyId={spyId}
                        filter={filter}
                        expanded={mode === 'chartSupply'}
                        onExpand={handleChartSupplyContainerExpand}
                        onCollapse={handleChartSupplyContainerCollapse}
                    />
                </div>
                <div className={chartDemandContainerClasses}>
                    <ChartDemandContainer 
                        spyId={spyId}
                        filter={filter}
                        expanded={mode === 'chartDemand'}
                        onExpand={handleChartDemandContainerExpand}
                        onCollapse={handleChartDemandContainerCollapse}
                    />
                </div>
                <div className={chartChartCompetitorListContainerClasses}>
                    <ChartCompetitorListContainer 
                        spyId={spyId}
                        filter={filter}
                        expanded={mode === 'chartCompetitors'}
                        onExpand={handleChartCompetitorListContainerExpand}
                        onCollapse={handleChartCompetitorListContainerCollapse}
                    />
                </div> 
            </>
        )
    }
    
    const widgetsContainerClasses = classNames(styles.WidgetsContainer, {})

    return (
        <div className={widgetsContainerClasses}>
            {renderContent()}
        </div>
    )
}